import React from "react";
import { TableProps, Table, Typography } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

interface DataType {
  key: string;
  feature: string;
  credits: boolean | string;
  basic: boolean | string;
  professional: boolean | string;
  enterprise: boolean | string;
}

const columns: TableProps<DataType>["columns"] = [
  {
    title: "Features",
    dataIndex: "feature",
    key: "features",
    render: (_, { feature }) => <Typography.Text>{feature}</Typography.Text>,
  },
  {
    title: "Credit Based",
    dataIndex: "credits",
    key: "credit_based",
    align: "center",
    render: (_, { credits }) =>
      typeof credits === "string" ? (
        <Typography.Text strong style={{ fontSize: "12px" }}>
          {credits}
        </Typography.Text>
      ) : credits ? (
        <CheckCircleOutlined style={{ color: "#52c41a" }} />
      ) : (
        <CloseCircleOutlined style={{ color: "#FF0024" }} />
      ),
  },
  {
    title: "Basic Plan",
    dataIndex: "basic",
    key: "basic_plan",
    align: "center",
    render: (_, { basic }) =>
      typeof basic === "string" ? (
        <Typography.Text strong style={{ fontSize: "12px" }}>
          {basic}
        </Typography.Text>
      ) : basic ? (
        <CheckCircleOutlined style={{ color: "#52c41a" }} />
      ) : (
        <CloseCircleOutlined style={{ color: "#FF0024" }} />
      ),
  },
  {
    title: "Professional Plan",
    dataIndex: "professional",
    key: "professional_plan",
    align: "center",
    render: (_, { professional }) =>
      typeof professional === "string" ? (
        <Typography.Text strong style={{ fontSize: "12px" }}>
          {professional}
        </Typography.Text>
      ) : professional ? (
        <CheckCircleOutlined style={{ color: "#52c41a" }} />
      ) : (
        <CloseCircleOutlined style={{ color: "#FF0024" }} />
      ),
  },
  {
    title: "Enterprise Plan",
    dataIndex: "enterprise",
    key: "enterprise_plan",
    align: "center",
    render: (_, { enterprise }) =>
      typeof enterprise === "string" ? (
        <Typography.Text strong style={{ fontSize: "12px" }}>
          {enterprise}
        </Typography.Text>
      ) : enterprise ? (
        <CheckCircleOutlined style={{ color: "#52c41a" }} />
      ) : (
        <CloseCircleOutlined style={{ color: "#FF0024" }} />
      ),
  },
];

const data: DataType[] = [
  {
    key: "1",
    feature: "No of Assessments",
    credits: "Custom",
    basic: "100",
    professional: "500",
    enterprise: "Custom",
  },
  {
    key: "2",
    feature: "No of Active Job Posts",
    credits: "Unlimited",
    basic: "3",
    professional: "10",
    enterprise: "Unlimited",
  },
  {
    key: "3",
    feature: "No of Recruiters",
    credits: "Unlimited",
    basic: "3",
    professional: "Unlimited",
    enterprise: "Unlimited",
  },
  {
    key: "4",
    feature: "Custom Branding",
    credits: true,
    basic: false,
    professional: true,
    enterprise: true,
  },
  {
    key: "5",
    feature: "Custom Domain",
    credits: true,
    basic: false,
    professional: true,
    enterprise: true,
  },
  {
    key: "6",
    feature: "Discount",
    credits: false,
    basic: "10% on Annual Mode",
    professional: "10% on Annual Mode",
    enterprise: true,
  },
];

const PlanFeatureTable: React.FC = () => {
  return <Table dataSource={data} columns={columns} pagination={false} />;
};

export default PlanFeatureTable;
